/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2f",".ManagerHotSale{margin-top:50px;border:1px solid #ededed}.ManagerHotSale .subTitle{position:relative;height:40px;background:#f2f2f2;border-bottom:1px solid #ededed}.ManagerHotSale .subTitle em{color:#f85231;font-size:14px;line-height:40px;margin-left:8px;font-weight:700}.ManagerHotSale .subTitle .p4p-rec-list{position:absolute;top:12px;margin:0;list-style:none;left:90px;height:20px;overflow:hidden;width:800px}.ManagerHotSale .subTitle .p4p-rec-list li{float:left}.ManagerHotSale .subTitle .p4p-rec-list li a{display:block;padding:0 10px;text-decoration:underline;color:#666}.ManagerHotSale .subTitle .p4p-rec-list li a:hover{color:#f40}.ManagerHotSale .subTitle .p4p-apply{text-align:left;position:absolute;right:10px;bottom:9px;width:100px;color:#666}.ManagerHotSale .item-wraper{height:270px;background:#fff;padding:14px 0 10px 17px}.ManagerHotSale .item-wraper .item a:hover{text-decoration:none}.ManagerHotSale .item-wraper .item{float:left;font-size:12px;margin-right:15px;width:178px;border:1px solid #f2f2f2}.ManagerHotSale .item-wraper .item.hover,.ManagerHotSale .item-wraper .item:hover{border-color:#f85300}.ManagerHotSale .item-wraper .item .imgContainer{height:178px;width:178px;overflow:hidden}.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:178px;height:178px;display:table-cell;text-align:center;vertical-align:middle}.ManagerHotSale .item-wraper .item .imgContainer .imgLink img{vertical-align:middle;max-width:none}.ManagerHotSale .item-wraper .item .titleWrap{padding-left:5px;overflow:hidden}.ManagerHotSale .item-wraper .item .icon-tmall{background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/service.png) -83px -129px no-repeat;font-size:0;float:left;width:16px;height:16px;margin-top:3px;margin-right:4px;display:inline-block}.ManagerHotSale .item-wraper .item .title{width:142px;height:30px;line-height:27px;float:left;overflow:hidden;color:#000;display:block}.ManagerHotSale .item-wraper .item .title .hl{color:#ef470f}.ManagerHotSale .item-wraper .item .title:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info{height:45px;padding:5px;line-height:30px}.ManagerHotSale .item-wraper .item .info .icon{width:27px;height:14px;background:url(//img.alicdn.com/tps/i2/T1RJKwFqRdXXXM4v6c-27-14.png) no-repeat;float:right;margin:7px 4px 0 0}.ManagerHotSale .item-wraper .item .info .price{font-size:16px;line-height:16px;margin-top:4px;color:#f40;font-family:arial,verdana,sans-serif}.ManagerHotSale .item-wraper .item .info .price strong{font-weight:700}.ManagerHotSale .item-wraper .item .info .price strong:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info .price .origin-price{text-decoration:line-through;color:#aaa;padding-left:4px;font-size:12px;font-weight:400}.ManagerHotSale .item-wraper .item .info .sales{float:left;line-height:20px;margin-top:4px;color:#333}.ManagerHotSale .item-wraper .item .info .sales strong{font-weight:400}.ManagerHotSale .item-wraper .item .info .sales:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info .title{color:#666}.ManagerHotSale .item-wraper .item .info #dsr-info-hover .dsr-info-list{display:block}.ManagerHotSale .item-wraper .item .info .dsr-info{display:block;position:relative;z-index:2;float:right;line-height:15px;width:95px;height:18px;margin-top:6px}.ManagerHotSale .item-wraper .item .info .dsr-info .active{text-decoration:none;border:1px solid #d9d9d9;height:16px;line-height:16px;padding-left:3px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-num{margin-left:5px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-tgr{position:relative;display:block;color:gray;cursor:default;outline:0;text-decoration:none}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-tgr .dropdown-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -129px -285px no-repeat}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{position:absolute;display:none;top:15px;width:93px;left:0;color:gray;list-style:none;background-color:#fff;border:1px solid #ddd;border-radius:0 0 3px 3px;margin-top:-15px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .morethan{color:#b30f00}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .listup-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -146px -285px no-repeat}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .lessthan{color:#20730f}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list span{display:block;height:18px;padding:2px 5px;font-weight:400;white-space:nowrap}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list span b{font-weight:400;padding-left:5px}@media screen and (min-width:1190px) and (max-width:1349px){.ManagerHotSale .item-wraper{height:305px}.ManagerHotSale .item-wraper .item{width:218px;margin-right:13px}.ManagerHotSale .item-wraper .item .imgContainer,.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:218px;height:218px}.ManagerHotSale .item-wraper .item .title{width:181px}.ManagerHotSale .item-wraper .item .info .dsr-info{width:105px}.ManagerHotSale .subTitle .p4p-rec-list{width:990px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:103px}}@media screen and (min-width:1350px){.ManagerHotSale .item-wraper{height:345px}.ManagerHotSale .item-wraper .item{width:248px}.ManagerHotSale .item-wraper .item .imgContainer,.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:248px;height:248px}.ManagerHotSale .item-wraper .item .title{width:211px}.ManagerHotSale .item-wraper .item .info .dsr-info{width:115px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:113px}.ManagerHotSale .subTitle .p4p-rec-list{width:1000px}}#body1190 .ManagerHotSale .item-wraper{height:305px}#body1190 .ManagerHotSale .item-wraper .item .info .dsr-info{width:105px}#body1190 .ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:103px}#body1190 .ManagerHotSale .subTitle .p4p-rec-list{width:990px}#body1190 .ManagerHotSale .item-wraper .item{width:218px;margin-right:13px}#body1190 .ManagerHotSale .item-wraper .item .imgContainer,#body1190 .ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:218px;height:218px}#body1190 .ManagerHotSale .item-wraper .item .title{width:181px}#body1350 .ManagerHotSale .item-wraper{height:345px}#body1350 .ManagerHotSale .item-wraper .item .info .dsr-info{width:115px}#body1350 .ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:113px}#body1350 .ManagerHotSale .subTitle .p4p-rec-list{width:1000px}#body1350 .ManagerHotSale .item-wraper .item{width:248px}#body1350 .ManagerHotSale .item-wraper .item .imgContainer,#body1350 .ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:248px;height:248px}#body1350 .ManagerHotSale .item-wraper .item .title{width:211px}");

var Util = require('../../lib/Util.js');

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"ManagerHotSale\"><div class=\"subTitle\"><em>掌柜热卖</em><div mx-guid=\"g0\u001f\" id=\"J_p4plink\" data-url=\"<%= $$.data.p4pTextLink%>\"><ul mx-guid=\"g1\u001f\" class=\"p4p-rec-list J_proxy_textlink\" data-linkpid=\"<%= $$.data.linkpid%>\"></ul></div><a href=\"http://zhitongche.taobao.com\" target=\"_blank\" class=\"p4p-apply\">我也要出现在这里</a></div><div mx-guid=\"g2\u001f\" class=\"item-wraper\" data-spm=\"3223322\">3\u001d</div></div>","subs":[{"keys":["data"],"path":"div[mx-guid=\"g0\u001f\"]","attr":"data-url=\"<%= $$.data.p4pTextLink%>\"","attrs":[{"n":"data-url"}]},{"keys":["data"],"path":"ul[mx-guid=\"g1\u001f\"]","attr":"data-linkpid=\"<%= $$.data.linkpid%>\"","attrs":[{"n":"data-linkpid"}]},{"keys":["entity"],"path":"div[mx-guid=\"g2\u001f\"]","tmpl":"<%$$.entity.forEach(function(a){%><div class=\"item\"><a href=\"<%= a.eurl%>\" class=\"imgLink\" target=\"_blank\"><div class=\"imgContainer\"><span class=\"imgLink\"><img data-ks-lazyload=\"<%= a.imgUrl%>_220x220.jpg\" src=\"//g.alicdn.com/s.gif\"></span></div><p class=\"titleWrap\"><%if(a.ismall=='1'){%><span class=\"icon-tmall\"></span><%}%><span class=\"title\" title=\"<%= a.title%>\"><%= a.title%></span></p><div class=\"info\"><p class=\"price\"><%if(a.promoPrice&&a.promoPrice!=''){%> &yen;<strong><%= a.promoPrice%></strong><span class=\"origin-price\">&yen;<%= a.price%></span><%}else{%><span>&yen;<strong><%= a.price%></strong></span><%}%></p><span class=\"sales\">销量：<%= a.sellCount%></span><div class=\"dsr-info\"><span class=\"active dsr-info-tgr\"><span class=\"icon-btn-dsr\">如实描述:</span><span class=\"dsr-info-num\"><%= a.dsrDescribe%></span><span class=\"dropdown-tgr-arrow\"></span></span><ul class=\"dsr-info-list\"><%if(a.dsrDescribeGap=='0'){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap==''){%><li><span class=\"morethan\">如实描述:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap&&a.dsrDescribeGap.indexOf('-')==-1){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrServiceGap=='0'){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap==''){%><li><span class=\"morethan\">服务态度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap&&a.dsrServiceGap.indexOf('-')==-1){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrDeliverGap=='0'){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap==''){%><li><span class=\"morethan\">发货速度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap&&a.dsrDeliverGap.indexOf('-')==-1){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}%></ul></div></div></a></div><%})%>","s":"3\u001d"}]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            DOM: null,
            Node: null,
            DataLazyLoad: null
        });
    },
    initShopHotsell: function initShopHotsell() {
        var DataLazyLoad = this.opt.DataLazyLoad,
            S = this.opt.S,
            DOM = this.opt.DOM,
            Node = this.opt.Node;

        function ShopHotsell() {
            this.init();
            this.events();
        }
        ShopHotsell.prototype.init = function () {
            var self = this;
            var ieVersion = parseInt(KISSY.UA.ie, 10);
            var resultContainer = S.one('.ManagerHotSale');
            var link = S.all('a', resultContainer);

            self.reg = /_\d{2,3}x\d{2,3}\.(jpg|gif)$/;
            self.resultContainer = resultContainer;

            // self.adjustSize();

            // 处理url
            S.each(link, function (item) {
                item.href = item.href.replace(/&amp;/g, '&');
            });

            //搜索词高亮处理
            if (window._SEARCHKEYWORDS && window._SEARCHKEYWORDS != "") {
                var keyword = decodeURIComponent(window._SEARCHKEYWORDS);
                /*高亮处理*/
                self._highLightKeyWords(resultContainer, keyword);
            }
            setTimeout(function () {
                self.getText();
            }, 800);

            // lazyload
            var lazyload = new DataLazyLoad({
                container: resultContainer,
                placeholder: "//g.alicdn.com/s.gif"
            });
            if (window._WEBP && lazyload._images) {
                S.each(lazyload._images, function (images) {
                    images = S.one(images);
                    if (images.attr("data-ks-lazyload").indexOf("_.webp") < 0) {
                        images.attr("data-ks-lazyload", images.attr("data-ks-lazyload") + "_.webp");
                    }
                });
            }
        };
        /*
        * 搜索文字链
        * */
        ShopHotsell.prototype.getText = function () {
            var self = this;
            var J_p4plink = S.one('#J_p4plink', self.resultContainer),
                dataUrl = J_p4plink.attr('data-url'),
                J_linkUl = J_p4plink.one('ul');
            self.requestLink(dataUrl, function (e) {
                var list = e.data.data1 || [];
                var itemList = [];
                S.each(list, function (thisitem, idx) {
                    var li = DOM.create('<li>');
                    if (idx > 15) return; //当idx大于10 的时候return只取10个词防止出现溢出的情况
                    var a = DOM.create('<a>', {
                        href: thisitem.clickUrl.replace(/&amp;/g, '&'), //new XTemplate(href).render(App.getData())
                        text: thisitem.title,
                        target: '_blank'
                    });
                    DOM.append(a, li);
                    itemList.push(li);
                });
                DOM.append(itemList, J_linkUl);
            });
        };
        ShopHotsell.prototype.requestLink = function (url, cb) {
            if (url == '') return;

            Util.sync(url, {}, cb, function (err) {});

            // S.io({
            //     url: url,
            //     dataType: 'jsonp',
            //     jsonp: 'cb',
            //     data: '',
            //     success: function (d) {
            //         if (cb && typeof cb == 'function') {
            //             cb(d);
            //         }
            //     },
            //     error: function () {
            //         //S.Event.fire(self, EVENT_ERROR);
            //     }
            // });
        };
        ShopHotsell.prototype.events = function () {
            var self = this;
            var resultContainer = self.resultContainer;
            // S.one(window).on('resize',function(){
            //     self.adjustSize(); 
            // }); 

            resultContainer.delegate('mouseover mouseout', '.dsr-info-tgr', function (e) {
                var dsrInfo = Node(e.currentTarget).parent();
                if (e.type == 'mouseover') {
                    dsrInfo.attr('id', 'dsr-info-hover');
                } else {
                    dsrInfo.attr('id', '');
                }
            });
            resultContainer.delegate('mouseover mouseout', '.dsr-info-list', function (e) {
                var dsrInfo = Node(e.currentTarget).parent();
                if (e.type == 'mouseover') {
                    dsrInfo.attr('id', 'dsr-info-hover');
                } else {
                    dsrInfo.attr('id', '');
                }
            });
        };
        /*
        * 判断屏幕宽度
        * @return num
        * */
        ShopHotsell.prototype.getBrowserWidth = function () {
            if (window.innerWidth) {
                return window.innerWidth;
            } else if (document.documentElement && document.documentElement.clientWidth != 0) {
                return document.documentElement.clientWidth;
            } else if (document.body) {
                return document.body.clientWidth;
            }
            return 0;
        };
        /*
        * 适应不同屏幕
        * */
        ShopHotsell.prototype.adjustSize = function () {
            var self = this,
                width = self.getBrowserWidth(),
                ct = S.one('.ManagerHotSale'),
                targets = S.all('img', ct);
            if (width >= 1350) {
                self.replaceImg(targets, '_250x250.jpg');
            } else if (width < 1349 && width >= 1190) {
                self.replaceImg(targets, '_220x220.jpg');
            } else {
                self.replaceImg(targets, '_190x190.jpg');
            }
        };
        /*
        * 替换图片后缀
        *  @param target DOM Object
        *  @param size   String 
        *  @return null
        * */
        ShopHotsell.prototype.replaceImg = function (target, size) {
            var self = this;
            for (var i = 0, len = target.length; i < len; i++) {
                var oldSrc = Node(target[i]).attr('src'),
                    newSrc = oldSrc.replace(self.reg, size);
                Node(target[i]).attr('src', newSrc);
            }
        };
        /*
        * 关键词高亮处理
        * @params wrapper DOM Object
        * */
        ShopHotsell.prototype._highLightKeyWords = function (wrapper, keyword) {
            var titleList = wrapper.all('.title');
            var i = 0,
                len = titleList.length;
            for (; i < len; i++) {
                titleList[i].innerHTML = this._replacement(titleList[i].innerHTML, keyword);
            }
        };
        /*
        *  替换关键词
        *  @params string String
        *  @return string
        * */
        ShopHotsell.prototype._replacement = function (string, keyword) {
            return string.replace(RegExp('(' + keyword.replace(/\W/g, function (e) {
                return '\\u' + ('000' + e.charCodeAt(0).toString(16)).slice(-4);
            }) + ')'), '<font class="hl">$1</font>');
        };
        new ShopHotsell();
    },
    render: function render() {
        var self = this;
        var root = window.root;

        KISSY.use("dom, node, kg/datalazyload/2.0.0/", function (S, DOM, Node, DataLazyLoad) {
            self.opt.Node = Node;
            self.opt.DataLazyLoad = DataLazyLoad;
            self.opt.DOM = DOM;

            // Util.sync('//odin.re.taobao.com/search_tbuad', {
            //     catid: root.url.catid,
            //     frcatid: root.url.frcatid,
            //     keyword: root.url.keyword,
            //     from: root.compExt.mosic,
            //     ac: root.cookie.cna,
            //     ip: root.env.ip,
            //     wangwangid: root.cookie.tracknick,
            //     offset: root.url.offset,
            //     count: root.compExt.count,
            //     pid: root.compExt.pid,
            //     refpid: root.url.refpid,
            //     buckid: root.env.buckid,
            //     p4pTags: root.compExt.p4pTags,
            //     clk1: root.url.clk1,
            //     elemtid: root.url.elemtid,
            //     propertyid: root.url.propertyid,
            //     loc: root.url.loc,
            //     gprice: root.url.gprice,
            //     ismall: root.url.ismall,
            //     page: root.url.page,
            //     creativeid: root.url.refpos,
            //     debug: root.url.debug
            // }, 

            //  data-url="//odin.re.taobao.com/search_tbuad?catid=<%= root.url.catid %>&frcatid=<%= root.url.frcatid %>&keyword=<%= root.url.keyword %>&from=<%= root.compExt.mosic %>&ac=<%= root.cookie.cna %>&ip=<%= root.env.ip %>&wangwangid=<%= root.cookie.tracknick %>&offset=<%= root.url.offset %>&count=<%= root.compExt.count %>&pid=<%= root.compExt.pid %>&refpid=<%= root.url.refpid %>&buckid=<%= root.env.buckid %>&p4pTags=<%= root.compExt.p4pTags %>&clk1=<%= root.url.clk1 %>&elemtid=<%= root.url.elemtid %>&propertyid=<%= root.url.propertyid %>&loc=<%= root.url.loc %>&gprice=<%= root.url.gprice %>&ismall=<%= root.url.ismall %>&page=<%= root.url.page %>&creativeid=<%= root.url.refpos %>&debug=<%= root.url.debug %>" 

            Util.sync(self.opt.url, {}, function (json) {
                self.updater.set({
                    // root: window.root,
                    data: {
                        linkpid: self.opt.linkpid,
                        p4pTextLink: self.opt.p4ptextlink
                        //odin.re.taobao.com/search_stext?catid=<%= root.url.catid %>&frcatid=<%= root.url.frcatid %>&keyword=<%= root.url.keyword %>&tlpid=<%= root.compExt.tlpid %>&refpid=<%= root.url.refpid %>&debug=<%= root.url.debug %>
                    },
                    entity: json.data.data1
                }).digest();

                self.initShopHotsell();
            }, function (err) {});
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/hotsellitem/index.js
// module id = 3
// module chunks = 1 2